import { axiosRequest } from '@/util/axios-request'

export function login(data) {
  return axiosRequest({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function userLogin(data) {
  return axiosRequest({
    url: '/auth/user/login',
    data
  })
}

export function fetchPermissionList() {
  return axiosRequest({
    url: '/auth/user/my',
    method: 'get'
  })
}

export function apiGetPermissionAll(params) {
  return axiosRequest({
    url: '/user/permission/all',
    method: 'get',
    params
  })
}

export function apiGetPermissionList(params) {
  return axiosRequest({
    url: '/user/permission/list',
    method: 'get',
    params
  })
}

export function apiSetPermission(data) {
  return axiosRequest({
    url: '/user/permission/grant',
    data
  })
}

export function getInfo(token) {
  return axiosRequest({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return axiosRequest({
    url: '/user/logout',
    method: 'post'
  })
}
